import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Form, Button, TextArea } from 'formik-semantic-ui';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwAccettazioneRejectModalValues {
  refusalComments: string;
}

interface PtwAccettazioneRejectModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  onSubmit: any;
}

export class PPtwAccettazioneRejectModal extends Component<PtwAccettazioneRejectModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button negative onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Reject'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Reject'} />
        </Modal.Header>
        <Modal.Content>
          <Form initialValues={{ refusalComments: '' }} onSubmit={this.props.onSubmit}>
            <TextArea label={t('Comment')} name="refusalComments" />
            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwAccettazioneRejectModal = withTranslation()(PPtwAccettazioneRejectModal);
